module.exports = __webpack_public_path__ + "img/H000070_windmill.1bc47227.png";